import React from "react";

function MainBadge({ children, className, ...props }: MainBadgePropsType) {
  return (
    <span
      className={` text-primary text-[12px] lg:text-[1rem] font-medium  px-2.5 py-0.5 rounded-md ${className}`}
      {...props}
    >
      {children}
    </span>
  );
}

export default MainBadge;
export type MainBadgePropsType = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLSpanElement>,
  HTMLSpanElement
>;
